import { Col } from "react-bootstrap";
import { TissueTypes } from "../../../../models";
import { useMemo } from "react";
import { TissueInformationFormProps } from ".";
import { useTIFFormData } from "../../../../hooks";

export function TIFScleraGrading({ tissueId }: Readonly<TissueInformationFormProps>) {
    const { tissue } = useTIFFormData({ tissueId });

    const scleraSize = useMemo(() => {
        switch (tissue?.tissueType?.name) {
            case TissueTypes.Sclera:
                return "Whole";
            case TissueTypes.Sclera1:
            case TissueTypes.Sclera2:
                return "Half";
            case TissueTypes.Quarter1:
            case TissueTypes.Quarter2:
            case TissueTypes.Quarter3:
            case TissueTypes.Quarter4:
                return "Quarter";
        }
    }, [tissue?.tissueType?.name]);

    if (!tissue) {
        return <div>No tissue found</div>;
    }

    return (
        <>
            <Col>
                <div className="mb-3">
                    <strong>PROCESSING</strong>
                </div>
                <div className="mb-2">
                    Sclera is processed in a Processing Theater or laminar flow hood using aseptic technique.
                </div>
                <div className="mb-2">
                    The posterior pole is emptied of its contents, then cleaned and trimmed both inside and out.
                </div>
                <div>
                    The shell is then submerged in Povidone-iodine and rinsed with saline before being submerged in
                    70%(or greater) ethyl alcohol.
                </div>
            </Col>
            <Col>
                <div className="mb-3">
                    <strong>POST-PROCESSING</strong>
                </div>
                <div className="mb-3">Sclera Size: {scleraSize} Sclera</div>
            </Col>
        </>
    );
}
